<template>
  <div class="settlement">
    <div class="settlecont">
      <div class="steps flex">
        <div
          class="step"
          v-for="(item, index) in 4"
          :key="index"
          :class="{
            sucess: index < ddstatus,
            proceed: index == ddstatus,
            pending: index > ddstatus,
          }"
        >
          <div class="status">
            <div class="suc">
              <img src="../../assets/contmodeldet/jssucess.png" />
            </div>
            <div class="pro">
              <img src="../../assets/contmodeldet/jsprocee.png" />
            </div>
            <div class="pend">{{ item }}</div>

            <div class="step_line">
              <div class="toptext">5-10分钟内律师来电</div>
            </div>
          </div>

          <div class="des">
            <div class="txt1">下单付款</div>
            <div class="protxt">进行中</div>
            <div class="suctxt">已完成</div>
            <div class="pendtxt">待进行</div>

            <div class="txt3_ac">2021-04-26 10:30</div>
            <div class="txt3">/</div>
          </div>
        </div>
      </div>

      <sub-title text="订单信息" />
      <div class="orderinfo">
        <div class="th between">
          <div>订单名称</div>
          <div>订单类型</div>
          <div>订单金额</div>
        </div>
        <div class="tr between">
          <div>
            <div>婚内财产协议-合同定制</div>
            <div class="zhushi">（3天内不限次修改，满意为止）</div>
          </div>
          <div>合同代写</div>
          <div>149.0元</div>
        </div>
      </div>

      <sub-title text="支付方式" />
      <div class="zffs between">
        <div class="payway flex_start">
          <div class="paywayradio">
            <el-radio v-model="payway" label="zfb"
              ><img src="../../assets/contmodeldet/zfzfb.png" alt="" />
              支付宝</el-radio
            >
          </div>
          <div class="paywayradio">
            <el-radio v-model="payway" label="wx"
              ><img
                src="../../assets/contmodeldet/zfwx.png"
                alt=""
              />微信</el-radio
            >
          </div>
        </div>
        <div class="submit" @click="sumbit">提交订单</div>
      </div>
    </div>
    <el-dialog  :visible.sync="dialogVisible" width="30%">
        <div class="message">付款成功,请等待律师联系</div>
    </el-dialog>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: { subTitle },
  data() {
    return {
      ddstatus: 0,
      payway: "zfb",
      dialogVisible: false,
    };
  },
  methods: {
    sumbit() {
        this.dialogVisible = true
    },
  },
};
</script>

<style lang="scss" scoped>
.settlement {
  background: #f8f8f8;
  padding: 50px 0;
  .settlecont {
    width: 1200px;
    margin: 0 auto;
    padding: 0 22px;
    height: 600px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    .steps {
      padding: 50px;
      width: 100%;
      .step {
        flex-basis: 33.3%;
        text-align: center;

        .status {
          position: relative;
          width: 100%;
          img {
            width: 55px;
            height: 55px;
          }
          .step_line {
            content: "";
            position: absolute;
            top: calc(50% - 2px);
            right: -50%;
            left: 50%;
            width: 98%;
            height: 4px;
            background-color: #e8e8e8;
            .toptext {
              position: absolute;
              top: -30px;
              width: 100%;
              left: 0;
              text-align: center;
              font-size: 14px;
              color: #999999;
            }
          }

          .suc,
          .pro,
          .pend {
            position: relative;
            z-index: 2;
            display: none;
          }
          .pend {
            width: 56px;
            height: 56px;
            line-height: 56px;
            text-align: center;
            margin: 0 auto;
            background: #e8e8e8;
            border-radius: 50%;
            font-size: 24px;
            color: #bbbbbb;
          }
        }
        .des {
          .txt1 {
            font-size: 18px;
            color: #333333;
            margin-top: 15px;
            margin-bottom: 10px;
          }
          .suctxt {
            font-size: 14px;
            color: #0465ea;
            display: none;
          }
          .protxt {
            font-size: 14px;
            color: #11bb65;
            display: none;
          }
          .pendtxt {
            font-size: 14px;
            color: #999999;
            display: none;
          }
          .txt3,
          .txt3_ac {
            display: none;
            margin-top: 10px;
            font-size: 14px;
            color: #999999;
          }
        }
        &:last-child {
          .step_line {
            display: none;
          }
        }

        &.sucess {
          .step_line {
            background-color: #0465ea;
          }
          .suc,
          .suctxt,
          .txt3_ac {
            display: block;
          }
        }
        &.proceed {
          .step_line::before {
            content: "";
            width: 50%;
            height: 100%;
            position: absolute;
            top: calc(50% - 2px);
            left: 0;
            background-color: #0465ea;
          }
          .pro,
          .protxt,
          .txt3_ac {
            display: block;
          }
        }
        &.pending {
          .pend,
          .pendtxt,
          .txt3 {
            display: block;
          }
        }
      }
    }

    .orderinfo {
      width: 1110px;
      height: 128px;
      background: #ffffff;
      margin: 24px auto 30px;
      border: 1px solid #e8e8e8;
      .th {
        div {
          flex: 1;
          height: 48px;
          line-height: 48px;
          text-align: center;
          background: #f8f8f8;
        }
      }
      .tr {
        height: 80px;
        > div {
          flex: 1;
          text-align: center;
          font-size: 14px;
          color: #333333;
        }
        .zhushi {
          margin-top: 6px;
          font-size: 12px;
          color: #ec0000;
        }
      }
    }

    .zffs {
      margin-top: 24px;
      padding-left: 20px;
      .paywayradio {
        width: 148px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #ececec;
        margin-right: 50px;
        img {
          width: 22px;
          height: 22px;
          margin-right: 8px;
        }
      }
      .submit {
        width: 160px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #ec3b3b;
        border-radius: 25px;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }

  .message{
        font-size: 22px;
        padding-bottom: 20px;
        color: #000;
  }
}
</style>